<template>
  <div class="hello lesson-custom-table">
    <h1>Welcome to the YTeach Admin Portal</h1>

    <GridTable
      v-if="stateFilterBySchool"
      ref="gridTable"
      id="StudentSubjectList"
      :key="componentKey"
      :title="`${title}${appendTitle || ''}`"
      urlPath="lessonsCms"
      :columns="columns"
      :schema="schema"
      :supportAddNew="false"
      :hasEditItem="false"
      :hasDeleteItem="false"
      :defaultServerParams="defaultServerParams"

    >
      <template v-slot:customButtons="slotProps">
        <!-- <router-link :to="{ name: 'StudentDetail', params: { id: slotProps.props.row._id }}" class="btn btn-success">View</router-link> -->
        <ModalComponent
          :id="slotProps.props.row.originalIndex"
          width="400"
          :component="modalLessonDetail(slotProps.props.row)"
          >View</ModalComponent
        >
      </template>
    </GridTable>
  </div>
</template>

<script>
import { Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import BaseList from '@/components/BaseList'

const appModule = namespace('app')
const lessonsModule = namespace('lessons')

@Component()
export default class HomePage extends BaseList {
  @appModule.State('filterBySchool') stateFilterBySchool
  @appModule.State('schools') stateSchools
  @lessonsModule.State('statuses') stateStatuses

  title = 'Activity'

  get columns() {
    return [
      {
        label: 'ID',
        field: '_id',
        hidden: true
      },
      {
        label: 'Subject',
        field: 'subject.name',
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: 'Filter by Subject', // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: 'keyup' // only trigger on enter not on keyup
        }
      },
      {
        label: 'School',
        field: 'school.name',
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: 'Filter by School', // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          filterDropdownItems:
            (this.stateSchools &&
              this.stateSchools.map(item => {
                return { value: item.id, text: item.name }
              })) ||
            [], // dropdown (with selected values) instead of text input
          isMultiselect: true,
          fieldNameFilter: 'schoolId'
          // filterFn: this.columnFilterFn, // custom filter function that
          // trigger: 'keyup' // only trigger on enter not on keyup
        }
      },
      {
        label: 'Student',
        field: 'student',
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: 'Filter by Student', // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: 'keyup' // only trigger on enter not on keyup
        },
        formatFn: val => {
          return `${val.firstName} ${val.lastName}`
        }
      },
      {
        label: 'Tutor',
        field: 'tutor.student',
        formatFn: val => {
          return `${val.firstName} ${val.lastName}`
        },
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: 'Filter by Tutor', // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: 'keyup', // only trigger on enter not on keyup
          fieldNameFilter: 'tutor'
        }
      },
      {
        label: 'Schedule Date',
        field: 'scheduledDate',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DDThh:mm', // expects 2018-03-16
        dateOutputFormat: 'M/D/YYYY hh:mma',
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: 'Filter by Schedule Date', // placeholder for filter input
          filterType: 'dateRange',
          filterValue: {} // initial populated value for this filter
        }
      },
      {
        label: 'Total Minutes',
        field: (row) => {
          // Show realMins for 'finish' and 'completed' statuses, otherwise show scheduledMins
          if (row.status === 'finish' || row.status === 'completed') {
            return row.realMins || 0
          }
          return row.scheduledMins
        },
        type: 'number'
      },
      {
        label: 'Status',
        field: 'status',
        type: 'text',
        formatFn: val => {
          return this.stateStatuses && this.stateStatuses[val] ? this.stateStatuses[val] : val
        },
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: 'Filter by Status', // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          filterDropdownItems:
            (this.stateStatuses &&
              Object.keys(this.stateStatuses).map(val => {
                return { value: val, text: this.stateStatuses[val] }
              })) ||
            [], // dropdown (with selected values) instead of text input
          isMultiselect: true
          // filterFn: this.columnFilterFn, // custom filter function that
          // trigger: 'keyup' // only trigger on enter not on keyup
        }
      },

      {
        label: 'Actions',
        field: 'actions'
      }
    ]
  }
  schema = null

  /* @Watch("stateStatuses", { immediate: true })
  onWatchStateStatuses(val, oldVal) {
    this.columns.find((item) => item.field === "status").field = (rowObj) => {
      return this.stateStatuses && this.stateStatuses[rowObj.status];
    };
  } */
  get defaultServerParams() {
    return {
      _fields:
        'status,scheduledMins,scheduledDate,requestedDate,approvedDate,realMins,extendedMins,student.firstName,student.lastName,student.grade.name,tutor.student.firstName,tutor.student.lastName,rate,school.name,subject.name',
      ...this.filter
    }
  }
  get filter() {
    return {
      schoolId: this.filteredBySchool
    }
  }
  modalLessonDetail(item) {
    return {
      modalTitle: 'Lesson Detail',
      component: () => import('@/components/students/_LessonDetail'),
      componentProps: {
        item,
        statusOptions: this.stateStatuses
      },
      events: {
        'status-updated': this.onStatusUpdated
      }
    }
  }

  onStatusUpdated(data) {
    // Refresh the table data when status is updated
    if (this.$refs.gridTable) {
      this.$refs.gridTable.refreshData()
    }
    
    // Also update the lesson data in the current modal if it's open
    // This ensures the popup shows the updated status immediately
    console.log('Status updated, refreshing data...', data)
  }












}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue